export default "__VITE_ASSET__CPS24Yzw__"